import Simple from "./Simple";
import NotFoundLoader from "./NotFoundLoader";

const loaderModule = { Simple, NotFoundLoader };
export default loaderModule;
